import type { DonationDetailsListParams } from "../../services/api";

export const DONATION_FILTER_ALL = "all";

/** UI filter state — search is separate from message filterset field */
export type DonationListFilterState = {
  search: string;
  message: string;
  donation_type: string;
  status: string;
  payment_mode: string;
  scheme: string;
};

export const donationListFilterInitialState: DonationListFilterState = {
  search: "",
  message: "",
  donation_type: DONATION_FILTER_ALL,
  status: DONATION_FILTER_ALL,
  payment_mode: DONATION_FILTER_ALL,
  scheme: DONATION_FILTER_ALL,
};

export type DonationTypeFilterOption = {
  value: string;
  label: string;
};

export type DonationSchemeFilterOption = {
  value: string;
  label: string;
};

export function countActiveDonationFilters(
  filters: DonationListFilterState
): number {
  let count = 0;
  if (filters.message.trim()) {
    count++;
  }
  if (filters.donation_type !== DONATION_FILTER_ALL) {
    count++;
  }
  if (filters.status !== DONATION_FILTER_ALL) {
    count++;
  }
  if (filters.payment_mode !== DONATION_FILTER_ALL) {
    count++;
  }
  if (filters.scheme !== DONATION_FILTER_ALL) {
    count++;
  }
  return count;
}

export function buildDonationListApiParams(
  filters: DonationListFilterState,
  page: number,
  pageSize: number
): DonationDetailsListParams {
  const params: DonationDetailsListParams = { page, page_size: pageSize };

  if (filters.search.trim()) {
    params.search = filters.search.trim();
  }
  if (filters.message.trim()) {
    params.message = filters.message.trim();
  }
  if (filters.donation_type !== DONATION_FILTER_ALL) {
    params.donation_type = filters.donation_type;
  }
  if (filters.status !== DONATION_FILTER_ALL) {
    params.status = filters.status;
  }
  if (filters.payment_mode !== DONATION_FILTER_ALL) {
    params.payment_mode = filters.payment_mode;
  }
  if (filters.scheme !== DONATION_FILTER_ALL) {
    params.scheme = filters.scheme;
  }

  return params;
}
